import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Stack,
    Box,
    CircularProgress,
    useTheme,
} from "@mui/material";
import { TokioMarineLogo } from "../icons/TokioMarineLogo";
import { globalFormatCurrencyBRL, globalMaskDocument } from "../../../shared/utils";

interface Props {
    open: boolean;
    onClose: () => void;
    data: any;
    onConfirm: () => void;
    loading?: boolean;
}

export function ModalFireConfirmContract({
    open,
    onClose,
    data,
    onConfirm,
    loading = false,
}: Props) {
    const theme = useTheme();

    if (!data) return null;

    const totalPrize = Number(data.insurance_prize ?? 0);
    const installments = Number(data.installment_number ?? 1);
    const installmentValue =
        installments > 0 ? totalPrize / installments : totalPrize;

    return (
        <Dialog
            open={open}
            onClose={loading ? undefined : onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}
        >
            {/* HEADER LIMPO, COM LOGO */}
            <DialogTitle
                sx={{
                    px: 3,
                    py: 2.5,
                    fontWeight: 600,
                    fontSize: "1.2rem",
                    letterSpacing: 0.4,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h5" sx={{ fontWeight: 300, color: "primary.main" }}>
                    Confirmar contratação
                </Typography>


                {/* Logo discreta */}
                <Box
                    sx={{
                        width: 90,
                        opacity: 0.7,
                        "& svg": { maxHeight: 32, width: "auto" },
                    }}
                >
                    <TokioMarineLogo />
                </Box>
            </DialogTitle>

            {/* BODY */}
            <DialogContent
                dividers
                sx={{
                    px: 3,
                    py: 3,
                    backgroundColor: theme.palette.grey[50],
                }}
            >
                {/* CLIENTE */}
                <Stack spacing={0.3} sx={{ mb: 2 }}>
                    <Typography variant="h6" fontWeight={700}>
                        {data.tenant_name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {globalMaskDocument(data.tenant_document)}
                    </Typography>
                </Stack>

                {/* BLOCO DE VALORES */}
                <Box
                    sx={{
                        backgroundColor: "white",
                        borderRadius: 2,
                        border: `1px solid ${theme.palette.divider}`,
                        p: 2,
                        mb: 2,
                    }}
                >
                    <Stack spacing={1}>
                        <Typography>
                            Valor total:
                            <strong> {globalFormatCurrencyBRL(totalPrize.toFixed(2))}</strong>
                        </Typography>

                        <Typography>
                            Parcelamento:
                            <strong>
                                {" "}
                                {installments}x de{" "}
                                {globalFormatCurrencyBRL(installmentValue.toFixed(2))}
                            </strong>
                        </Typography>
                    </Stack>
                </Box>

                <Typography variant="body2" color="text.secondary">
                    Ao confirmar, geraremos a apólice e finalizaremos o orçamento.
                </Typography>
            </DialogContent>

            {/* FOOTER */}
            <DialogActions
                sx={{
                    px: 3,
                    py: 2,
                    backgroundColor: "background.paper",
                }}
            >
                <Button onClick={onClose} disabled={loading} sx={{ fontWeight: 500 }}>
                    Cancelar
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    onClick={onConfirm}
                    sx={{ minWidth: 120, fontWeight: 600 }}
                >
                    {loading ? (
                        <Stack direction="row" spacing={1} alignItems="center">
                            <CircularProgress size={16} color="inherit" />
                            <span>Processando...</span>
                        </Stack>
                    ) : (
                        "Confirmar"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
